import { Helmet } from 'react-helmet';
import MainBanner from 'components/Dashboard/MainBanner';
import Feature from '../../components/Dashboard/Feature';
import TryEarkick from '../../components/Dashboard/TryEarkick';
import Faq from '../../components/Faq';

const Dashboard = ({ canonical, language = 'en' }) => {
  return (
    <div className="main-content flex-column dashboard" style={{ background: '#FFFEF5' }}>
      {language === 'en' && 
        <Helmet>
          <link rel="canonical" href={ canonical } />
          <title>Your Anonymous, Personal AI Chat Bot for Self-Care</title>
          <meta name="description" content="Measure & improve your mental health in real time with your personal AI chat bot. Fully anonymous and private, available 24/7 with daily insights for you." data-react-helmet="true" />
        </Helmet>
      }
      {language === 'de' &&
        <Helmet>
          <link rel="canonical" href={ canonical } />
          <title>Earkick - Persönlicher KI-Therapeut Chatbot | Kostenlos starten</title>
          <meta name="description" content="Erfasse und stärke deine mentale Gesundheit in Echtzeit mit deinem persönlichen KI-Chatbot. Keine Anmeldung. Anonym. 24/7 für dich da. " data-react-helmet="true" />
        </Helmet>
      }
      <MainBanner language={language} />
      <Feature language={language} />
      <TryEarkick language={language} />
      <Faq language={language} />
    </div>
  );
};

export default Dashboard;
